import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TagInputModule } from 'ngx-chips';
import { FooterNewComponent } from './component/footer-new/footer-new.component';
import { HeaderNewComponent } from './component/header-new/header-new.component';
import { UpdateStripComponent } from './component/update-strip/update-strip.component';
import { PaginationComponent } from './component/pagination/pagination.component';
import { SearchComponentComponent } from './component/search-component/search-component.component';
import { SidebarComponent } from './component/sidebar/sidebar.component';
import { ScrollToBottomBtnComponent } from './component/scroll-to-bottom-btn/scroll-to-bottom-btn.component';
import { SortableHeaderComponent } from './component/sortable-header/sortable-header.component';
import { FilterDropdownComponent } from './component/filter-dropdown/filter-dropdown.component';
import { HoverZoomDirective } from './directives/hover-zoom.directive';
import { NftImageDirective } from './directives/nft-image.directive';
import { RestrictZeroDirective } from './directives/restrict-zero.directive';
import { ToolTipDirective } from './directives/tool-tip.directive';
import { TruncatedTooltipDirective } from './directives/truncated-tooltip.directive';
import { AttributeFilterPipe } from './pipes/attribute-filter.pipe';
import { ContentSlicePipe } from './pipes/content-slice.pipe';
import { ContractNamePipe } from './pipes/contract-name.pipe';
import { DayFinderPipe } from './pipes/day-finder.pipe';
import { DisplayNamePipe } from './pipes/display-name.pipe';
import { ExpiryDatePipe } from './pipes/expiry-date.pipe';
import { LastseenPipe } from './pipes/lastseen.pipe';
import { MethodFilterPipe } from './pipes/method-filter.pipe';
import { NftNamesPipe } from './pipes/nft-names.pipe';
import { SafeResourceUrlPipe } from './pipes/safe-resource-url.pipe';
import { UtcConverterPipe } from './pipes/utc-converter.pipe';
import { VariableTypegetPipe } from './pipes/variable-typeget.pipe';
import { ProgressModalComponent } from './progress-modal/progress-modal.component';
import { UiModalComponent } from './ui-modal/ui-modal.component';
import { LoanEndDatePipe } from './pipes/loan-end-date.pipe';
import { ThousandSeparatorPipe } from './pipes/thousand-separator.pipe';
import { TwoDecimalDirective } from './directives/two-decimal.directive';
import { DatePipe } from './pipes/date.pipe';
import { CurrencyAmountPipe } from './pipes/currency-amount.pipe';
import { ReadableDatePipe } from './pipes/readable-date.pipe';
import { CurrencySymbolPipe } from './pipes/currency-symbol.pipe';

const pipes = [SafeResourceUrlPipe, LastseenPipe, UtcConverterPipe, ContentSlicePipe, ContractNamePipe, VariableTypegetPipe, DayFinderPipe, UtcConverterPipe, ContentSlicePipe,DisplayNamePipe];
const component = [HeaderNewComponent, FooterNewComponent, SidebarComponent, UiModalComponent, ProgressModalComponent, SearchComponentComponent]
@NgModule({
    declarations: [
        UiModalComponent,
        ProgressModalComponent,
        SearchComponentComponent,
        SafeResourceUrlPipe, LastseenPipe, UtcConverterPipe, ContentSlicePipe, ContractNamePipe, VariableTypegetPipe, DayFinderPipe, UtcConverterPipe, ContentSlicePipe,
        HeaderNewComponent, FooterNewComponent, SidebarComponent, UiModalComponent, ProgressModalComponent, SearchComponentComponent, ToolTipDirective, TruncatedTooltipDirective, PaginationComponent, MethodFilterPipe, ExpiryDatePipe, AttributeFilterPipe, RestrictZeroDirective, NftNamesPipe, DisplayNamePipe, LoanEndDatePipe, ThousandSeparatorPipe, TwoDecimalDirective, DatePipe, CurrencyAmountPipe, ReadableDatePipe, CurrencySymbolPipe, ScrollToBottomBtnComponent, HoverZoomDirective, NftImageDirective, SortableHeaderComponent, FilterDropdownComponent
    ],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule, TagInputModule, ModalModule, RouterModule, UpdateStripComponent],
    exports: [
        PaginationComponent,
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        TagInputModule,
        ModalModule,
        SafeResourceUrlPipe, LastseenPipe, UtcConverterPipe, ContentSlicePipe, ContractNamePipe, VariableTypegetPipe, DayFinderPipe, UtcConverterPipe, ContentSlicePipe,ToolTipDirective,TruncatedTooltipDirective,RestrictZeroDirective,MethodFilterPipe,ExpiryDatePipe,AttributeFilterPipe,
        HeaderNewComponent, FooterNewComponent, SidebarComponent, UiModalComponent, ProgressModalComponent, SearchComponentComponent, NftNamesPipe,DisplayNamePipe, LoanEndDatePipe, ThousandSeparatorPipe, TwoDecimalDirective, CurrencyAmountPipe, ReadableDatePipe, CurrencySymbolPipe, ScrollToBottomBtnComponent, HoverZoomDirective, NftImageDirective, SortableHeaderComponent, FilterDropdownComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
